<sc-loading-spinner [isLoading]="isLoading" [fitHeight]="true">
    <ng-container *ngIf="project && articleTypeService.initialized && configurationService.initialized">
        <sc-padding [fitHeight]="true">
            <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
                <sc-title>{{ 'Project' | translate: ['erp.ui.project-admin.title', translationService.language]}}
                </sc-title>
                <sc-content-spacer [vertical]="true"></sc-content-spacer>
                <sc-bordered-tile>
                    <sc-padding>
                        <app-project-masterdata [project]="project"
                            (projectChanged)="onProjectChanged()"></app-project-masterdata>
                    </sc-padding>
                </sc-bordered-tile>
                <sc-content-spacer [vertical]="true"></sc-content-spacer>
                <sc-sub-title>{{ 'Structure' | translate: ['erp.ui.project-admin.subtitle.structure',
                    translationService.language]}}
                    <sc-content-spacer [grow]="true"></sc-content-spacer>
                    <button mat-stroked-button (click)="addRootNode()" *ngIf="project != null">
                        <mat-icon><sc-icon iconClass="fa-plus"></sc-icon></mat-icon>
                        {{ 'add' | translate: ['erp.ui.project-admin.action.add-root-node',
                        translationService.language]}}
                    </button>
                </sc-sub-title>
                <sc-content-spacer [vertical]="true" [half]="true"></sc-content-spacer>
                <sc-flex-fitting-content [vertical]="true">
                    <sc-bordered-tile [fitHeight]="true">
                        <app-project-structure [project]="project"
                            (projectChanged)="onProjectChanged()"></app-project-structure>
                    </sc-bordered-tile>
                </sc-flex-fitting-content>
            </sc-flex>
        </sc-padding>
    </ng-container>
</sc-loading-spinner>
